"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMplTokenAuthRulesProgramId = exports.getMplTokenAuthRulesProgram = exports.createMplTokenAuthRulesProgram = exports.MPL_TOKEN_AUTH_RULES_PROGRAM_ID = void 0;
const umi_1 = require("@metaplex-foundation/umi");
exports.MPL_TOKEN_AUTH_RULES_PROGRAM_ID = (0, umi_1.publicKey)('auth9SigNpDKz4sJJ1DfCTuZrZNSAgh9sFD3rboVmgg');
function createMplTokenAuthRulesProgram() {
    return {
        name: 'mplTokenAuthRules',
        publicKey: exports.MPL_TOKEN_AUTH_RULES_PROGRAM_ID,
        getErrorFromCode: () => null,
        getErrorFromName: () => null,
        isOnCluster: () => true,
    };
}
exports.createMplTokenAuthRulesProgram = createMplTokenAuthRulesProgram;
function getMplTokenAuthRulesProgram(context, clusterFilter) {
    return context.programs.get('mplTokenAuthRules', clusterFilter);
}
exports.getMplTokenAuthRulesProgram = getMplTokenAuthRulesProgram;
function getMplTokenAuthRulesProgramId(context, clusterFilter) {
    return context.programs.getPublicKey('mplTokenAuthRules', exports.MPL_TOKEN_AUTH_RULES_PROGRAM_ID, clusterFilter);
}
exports.getMplTokenAuthRulesProgramId = getMplTokenAuthRulesProgramId;
//# sourceMappingURL=mplTokenAuthRules.js.map